var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',[_vm._v("la-clipboard-list")])
}
var staticRenderFns = []

export { render, staticRenderFns }